import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api/trace`;

export const traceApi = {
  config: () => axios.get(`${API}/config`).then((r) => r.data),
  links: (etype, eid) => axios.get(`${API}/links/${etype}/${eid}`).then((r) => r.data),
  createLink: (b) => axios.post(`${API}/links`, b).then((r) => r.data),
  deleteLink: (id, reason) => axios.delete(`${API}/links/${id}`, { params: reason ? { reason } : {} }).then((r) => r.data),
  timeline: (etype, eid) => axios.get(`${API}/timeline/${etype}/${eid}`).then((r) => r.data),
  search: (ttype, q) => axios.get(`${API}/search/${ttype}`, { params: { q } }).then((r) => r.data),
  warnings: (etype, eid) => axios.get(`${API}/warnings/${etype}/${eid}`).then((r) => r.data),
  summary: () => axios.get(`${API}/summary`).then((r) => r.data),
  putSettings: (b) => axios.put(`${API}/settings`, b).then((r) => r.data),
  backfill: (dryRun) => axios.post(`${API}/backfill`, null, { params: { dry_run: dryRun } }).then((r) => r.data),
  linksAdmin: (includeDeleted) => axios.get(`${API}/links-admin`, { params: { include_deleted: includeDeleted } }).then((r) => r.data),

  // Phase 5 — Graph traversal + AI Suggestions
  graph: (etype, eid, depth = 2) =>
    axios.get(`${API}/graph/${etype}/${eid}`, { params: { depth } }).then((r) => r.data),
  suggest: (etype, eid, limit = 5) =>
    axios.post(`${API}/suggest/${etype}/${eid}`, { limit }).then((r) => r.data),
  listSuggestions: (etype, eid, status = 'pending') =>
    axios.get(`${API}/suggestions`, {
      params: { entity_type: etype, entity_id: eid, status },
    }).then((r) => r.data),
  approveSuggestion: (sid) =>
    axios.post(`${API}/suggestions/${sid}/approve`).then((r) => r.data),
  rejectSuggestion: (sid, reason) =>
    axios.post(`${API}/suggestions/${sid}/reject`, { reason: reason || null }).then((r) => r.data),
  suggestionsQueue: (status = 'pending') =>
    axios.get(`${API}/suggestions/queue`, { params: { status } }).then((r) => r.data),
};

// module-level config cache — every panel mount shares one fetch per page load
let _cfgPromise = null;
export const traceConfig = () => {
  if (!_cfgPromise) {
    _cfgPromise = traceApi.config().catch(() => { _cfgPromise = null; return { enabled: false, modules: {} }; });
  }
  return _cfgPromise;
};
export const clearTraceConfigCache = () => { _cfgPromise = null; };
